import { AdviceEditor } from 'modules/ui/SqlAutocomplete/types';

export const getIncisionAndIndicatorsCompletions = <T extends { name: string }>(incisionsAndIndicators: T[]) =>
  (incisionsAndIndicators || []).reduce<AdviceEditor[]>((acc, el: T) => {
    acc.push({ caption: el.name, value: el.name });
    return acc;
  }, []);
